import { InfoOutlined } from '@mui/icons-material'
import { Checkbox, Grid, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { IRequestPermissionFormData } from 'schema/authentication/request-permission'

interface AuthorizationOptionParams {
  name:
    | 'cadastraisDosTitulastes'
    | 'cadastraisDosDependentes'
    | 'informacoesDaEmpresa'
    | 'contratosDeTrabalhosDosTitulares'
    | 'historicoDeDadosCadastrais'
    | 'historicoDeAfastamentos'
    | 'historicoDeContratosDeTrabalho'
    | 'informacoesDaFolha'
  title: string
  description: string
  isLoading: boolean
  control: Control<IRequestPermissionFormData, Object>
  setValue: any
  handleChange: (e: any) => void
}

const AuthorizationOption: React.FC<AuthorizationOptionParams> = ({
  name,
  title,
  description,
  isLoading,
  control,
  setValue,
  handleChange,
}) => {
  return (
    <Grid
      container
      spacing={1}
    >
      <Grid
        item
        xs={2}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <Controller
          name={name}
          control={control}
          render={({ field: props }) => (
            <Checkbox
              {...props}
              sx={{
                mt: '-5px',

                '&.Mui-disabled': {
                  opacity: '0.08',
                },
              }}
              color='primary'
              disabled={isLoading}
              checked={props.value}
              onChange={(e) => {
                setValue(name, e.target.checked)
                handleChange(e)
              }}
            />
          )}
        />
      </Grid>

      <Grid
        item
        xs={8}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          mt: '-5px',
        }}
      >
        <Typography
          sx={{
            fontSize: '14.5px',
            lineHeight: '19px',
            fontWeight: '400',
            mt: '-5px',
          }}
        >
          {title}
        </Typography>
      </Grid>

      <Grid
        item
        xs={2}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          mt: '-5px',
        }}
      >
        <Tooltip
          title={description}
          arrow
        >
          <InfoOutlined />
        </Tooltip>
      </Grid>
    </Grid>
  )
}

export default AuthorizationOption
